module.exports = __webpack_public_path__ + "media/images/check-1-0346cacf9980c3359e13a962e62509ad.png";